import { useQuery } from "@tanstack/react-query";
import { getDungeonIds } from "../../api/quests/dungeonIds";

export default function useDungeons() {
  const {
    isLoading,
    isFetching,
    error,
    data: dungeonIds,
  } = useQuery<string[]>({
    queryKey: ["lut"],
    queryFn: () => getDungeonIds(),
  });

  return {
    isLoading: isLoading || isFetching,
    error,
    dungeonIds,
  };
}
